import script from "./MenuItemVenue.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItemVenue.vue?vue&type=script&setup=true&lang=js"

import "./MenuItemVenue.vue?vue&type=style&index=0&id=64447d6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64447d6c"]])

export default __exports__